import React, { useEffect, useMemo, useState } from "react";
import styles from "@/styles/detail/DetailBookingSidebar/DetailBookingConfigurator.module.scss";
import {
    ENUM_ECCESSO,
    ERoomType,
    ETourLanguage,
    ETourOption,
    ETypePackage,
    InfoType,
} from "@/models/common/enums";
import InfoModalGeneral from "@/components/common/info/InfoModalGeneral";
import {
    cancellationPolicyContent,
    dateContent,
    extraNightsContent,
    languageContent,
    nightsContent,
    priceContent,
    qualityPremiumContent,
} from "@/utils/mockData/infoMock";
import InfoModalDouble from "@/components/common/info/InfoModalDouble";
import InfoModalVideo from "@/components/common/info/InfoModalVideo";
import moment from "moment";
import { useQuery } from "@tanstack/react-query";
import {
    getExcludedDaysSession,
    getPackageDetailByTitle,
} from "@/utils/queries";
import {
    SlotsReadableTO,
    TourReadableTO,
    TourResponseTO,
} from "@/models/detail";
import Link from "next/link";
import { useStore } from "@/store/index";
import { IRoom, ISaveCheckoutData } from "@/models/checkout";
import InfoModalPremium from "@/components/common/info/InfoModalPremium";
import { useRouter } from "next/router";
import useCalculatePrice from "@/utils/hooks/useCalculatePrice";
import { useCurrency } from "@/utils/hooks/useCurrency";
// import LanguageSectionDetail from "./LanguageSectionDetail";
import TagManager from "react-gtm-module";
import adapterTourViewItemGAnalytics, {
    adapterItemGAnalytics,
} from "@/models/tour";
import { addToCart } from "@/utils/analytics/tagmanager";
import DatePickerSectionDetail from "./DatePickerSectionDetail";
import RoomTravellersSectionDetail from "./RoomTravellersSectionDetail";
import ChooseExperienceSectionDetail from "./ChooseExperienceSectionDetail";
import PackageConfigurationSectionDetail from "./PackageConfigurationSectionDetail";
import FinalPriceSectionDetail from "./FinalPriceSectionDetail";
import ButtonBuySectionDetail from "./ButtonBuySectionDetail";

const DetailBookingConfigurator = ({
    isPremium,
    setIsPremium,
    slots,
    tourId,
    days,
    typePackage,
    slotsPremium,
    slotsQuality,
    languages,
}: {
    tourId: string;
    setIsPremium: (el: boolean) => void;
    isPremium: boolean;
    slots: SlotsReadableTO[];
    days: string;
    typePackage: ETypePackage;
    // eslint-disable-next-line react/no-unused-prop-types
    priceQuality: number;
    // eslint-disable-next-line react/no-unused-prop-types
    pricePremium: number;
    slotsPremium: SlotsReadableTO[];
    slotsQuality: SlotsReadableTO[];
    languages: ETourLanguage[];
}) => {
    // const { PlayLine } = mediaControlSvg;

    /*
     IMPORTANT
     E' RICHIESTA DI PLAYITALY DI AVERE SELEZIONATO SEMPRE E SOLO INGLESE COME LINGUA DEL TOUR
     E' STATA INIBITA LA SEZIONE LanguageSectionDetail
    */

    const router = useRouter();
    const { slug } = router.query;
    const { currency } = useCurrency();

    // Ottieni packageDetail dalla query
    const { data: packageDetail } = useQuery({
        queryKey: ["packageDetailByTitle", slug?.[0], currency],
        queryFn: () => getPackageDetailByTitle(slug?.[0] as string),
        refetchInterval: false,
        enabled: !!slug?.[0],
    });

    const [infoContent, setInfoContent] = useState<InfoType>(InfoType.PRICE);
    // const [clickDate, setClickDate] = useState<boolean>(
    //     router.query.clickDate
    //         ? JSON.parse(router.query.clickDate as string)
    //         : false
    // );
    const [clickDate, setClickDate] = useState<boolean>(false);
    // const [clickLanguage, setClickLanguage] = useState<boolean>(
    //     router.query.clickLanguage
    //         ? JSON.parse(router.query.clickLanguage as string)
    //         : false
    // );
    // const [eccessoList, setEccessoList] = useState<ENUM_ECCESSO[]>(
    //     router.query.eccessoList
    //         ? JSON.parse(router.query.eccessoList as string)
    //         : []
    // );
    // const [pets, setPets] = useState<boolean>(
    //     router.query.pets ? JSON.parse(router.query.pets as string) : false
    // );
    const [eccessoList, setEccessoList] = useState<ENUM_ECCESSO[]>([]);
    const [pets, setPets] = useState<boolean>(false);

    const [show, setShow] = useState(false);
    const dispatchCheckout = useStore(state => state.dispatchCheckout);
    const discountAmount = useStore(
        state => state.checkoutState.orderData.coupon?.value
    );

    const { data: daysExcluded, refetch } = useQuery({
        queryKey: ["exclusionDays", tourId],
        queryFn: () => getExcludedDaysSession(tourId),
    });

    const toggleInfoModal = (info: InfoType) => {
        if (info === InfoType.DATE) refetch();
        setInfoContent(info);
        setShow(true);
    };

    const dateFormat = "YYYY-MM-DD";

    const getFirstUsefulDate = (
        excludedDates: string[] | undefined,
        date?: Date
    ) => {
        const currentDate = moment();
        const found = excludedDates?.find(
            element => element === currentDate.format(dateFormat)
        );
        if (found) {
            const sortedExcludedDates = excludedDates?.sort((a, b) => {
                return moment(a).diff(b);
            });
            const excludeDate = sortedExcludedDates?.find(
                (currentElement, index, arr) =>
                    !moment(currentElement)
                        .add(1, "day")
                        .isSame(arr.at(index + 1)) &&
                    moment(currentElement)
                        .add(1, "day")
                        .isAfter(date ?? currentDate.toDate())
            );
            return moment(excludeDate).add(1, "day").toDate();
        }
        return currentDate.toDate();
    };
    // const [startDate, setStartDate] = useState<Date>(
    //     router.query.clickDate && router.query.selectedDate
    //         ? moment(router.query.selectedDate as string, "DD/MM/YYYY").toDate()
    //         : getFirstUsefulDate(
    //               isPremium
    //                   ? daysExcluded?.toExcludePremium
    //                   : daysExcluded?.toExcludeQuality
    //           )
    // );

    // const [startDateView, setStartDateView] = useState<Date | null>(
    //     router.query.clickDate && router.query.selectedDate
    //         ? moment(router.query.selectedDate as string, "DD/MM/YYYY").toDate()
    //         : null
    // );

    const [startDate, setStartDate] = useState<Date>(
        getFirstUsefulDate(
            isPremium
                ? daysExcluded?.toExcludePremium
                : daysExcluded?.toExcludeQuality
        )
    );
    const [startDateView, setStartDateView] = useState<Date | null>(null);

    const { overrideDate, discountedDates } = useMemo(() => {
        const override =
            (isPremium
                ? daysExcluded?.overridePremium
                : daysExcluded?.overrideQuality) || [];
        const discounted = override.reduce((acc, value) => {
            return value.discount ? [...acc, value.day] : acc;
        }, [] as string[]);
        return { overrideDate: override, discountedDates: discounted };
    }, [daysExcluded, isPremium]);

    const selectedSlot = useMemo(() => {
        return slots.find(slot =>
            moment(moment(startDate).format(dateFormat)).isBetween(
                moment(slot.startDate),
                moment(slot.endDate),
                undefined,
                "[]"
            )
        );
    }, [slots, startDate]);

    const roomStore = useStore(state => state.checkoutState.orderData.rooms);

    const overrideDateFind = useMemo(() => {
        const selectedOverride = overrideDate.find(value =>
            moment(startDate).isSame(value.day)
        );
        return selectedOverride?.roomsOverride ?? [];
    }, [overrideDate, startDate]);

    const calculateSelectedSlot = (item: IRoom) => {
        const idxSlot =
            item.type === ERoomType.SINGLE
                ? 0
                : item.type === ERoomType.DOUBLE
                ? 1
                : 2;

        if (overrideDateFind.length > 0) {
            return overrideDateFind.at(idxSlot);
        }

        return selectedSlot?.rooms.at(idxSlot);
    };

    const [errorGuest, setErrorGuest] = useState<number>(0);

    const totalAmount = useStore(
        state => state.checkoutState.orderData.totalAmount
    );

    const showModalPremium = useMemo(() => {
        if (!isPremium && startDate) {
            const selectedSlotPremium = slotsPremium.find(slot =>
                moment(moment(startDate).format(dateFormat)).isBetween(
                    moment(slot.startDate),
                    moment(slot.endDate),
                    undefined,
                    "[]"
                )
            );

            return !!selectedSlotPremium;
        }
        return false;
    }, [isPremium, slotsPremium, startDate]);

    const rooms = useStore(state => state.checkoutState.orderData.rooms);
    const { languageSelected } = useStore(state => state.checkoutState);
    const setErrorMessage = useStore(state => state.setErrorMsg);
    const dispatchCommon = useStore(state => state.dispatchCommon);

    const priceTotal = useCalculatePrice({
        isPremium,
        rooms,
        slots,
        startDate: startDate ? startDate.toDateString() : "",
        tourId,
    });

    const priceQualityUse = useCalculatePrice({
        isPremium: false,
        rooms,
        slots: slotsQuality,
        startDate: startDate ? startDate.toDateString() : "",
        tourId,
    });

    const pricePremiumUse = useCalculatePrice({
        isPremium: true,
        rooms,
        slots: slotsPremium,
        startDate: startDate ? startDate.toDateString() : "",
        tourId,
    });

    // eslint-disable-next-line sonarjs/cognitive-complexity
    const onBuy = (isPremiumFlag: boolean) => {
        if (selectedSlot) {
            dispatchCommon({ type: "RESET_COMMON" });

            if (isPremiumFlag) setIsPremium(true);

            const currentIsPremium = isPremiumFlag ? true : isPremium;
            const currentSlots = currentIsPremium ? slotsPremium : slotsQuality;

            // Rinomina la variabile interna per evitare shadow
            const selectedSlotCurrentInner = currentSlots.find(slot =>
                moment(moment(startDate).format("YYYY-MM-DD")).isBetween(
                    moment(slot.startDate),
                    moment(slot.endDate),
                    undefined,
                    "[]"
                )
            );

            const calculatedPrice = rooms.reduce((total, room) => {
                const idxSlot =
                    room.type === ERoomType.SINGLE
                        ? 0
                        : room.type === ERoomType.DOUBLE
                        ? 1
                        : 2;
                const roomPrice = selectedSlotCurrentInner?.rooms.at(idxSlot);
                return roomPrice ? total + +roomPrice.grossPrice : total;
            }, 0);

            const finalTotalAmount = calculatedPrice - (discountAmount || 0);

            // Invia l'evento add_to_cart solo dopo la conferma dell'utente
            if (packageDetail) {
                try {
                    let itemData;

                    // Se è TourResponseTO, usa adapterTourViewItemGAnalytics
                    if ("quality" in packageDetail) {
                        itemData = adapterTourViewItemGAnalytics(
                            packageDetail as TourResponseTO,
                            isPremiumFlag
                        );
                    } else {
                        // Se è TourReadableTO, usa adapterItemGAnalytics direttamente
                        const itemVariant = isPremiumFlag
                            ? ETourOption.PREMIUM
                            : ETourOption.QUALITY;
                        const tourReadable = packageDetail as TourReadableTO;
                        const item = adapterItemGAnalytics(
                            tourReadable,
                            itemVariant
                        );
                        itemData = {
                            currency: "EUR",
                            value: tourReadable.price || 0.0,
                            items: [item],
                        };
                    }

                    const itemToAdd = itemData.items[0];
                    const numberRooms = rooms.length;
                    const numberPeople = rooms.reduce(
                        (acc, room) =>
                            acc +
                            room.adults +
                            room.children.length +
                            room.newborns,
                        0
                    );

                    const dataLayerPayload = addToCart(
                        itemToAdd,
                        finalTotalAmount,
                        numberRooms,
                        numberPeople
                    );

                    TagManager.dataLayer(dataLayerPayload);
                } catch (error) {
                    console.error("Error generating add_to_cart event:", error);
                }
            }

            const queryData: Partial<ISaveCheckoutData> = {
                tourId,
                totalAmount: finalTotalAmount,
                amount: finalTotalAmount,
                date: startDate?.toISOString(),
                rooms: rooms?.map(room => ({
                    ...room,
                })),
                option: isPremiumFlag
                    ? ETourOption.PREMIUM
                    : ETourOption.QUALITY,
                language: languageSelected,
                pets,
                eccessoList,
            };

            router.push(
                {
                    pathname: "/checkout",
                    query: {
                        checkoutData: JSON.stringify(queryData),
                    },
                },
                undefined,
                { shallow: true }
            );
        } else {
            setErrorMessage({
                message: "Tour not available for the selected date",
            });
        }
    };

    const modalsInfo = {
        [InfoType.PRICE]: (
            <InfoModalGeneral
                content={priceContent}
                show={show}
                setShow={setShow}
            />
        ),
        [InfoType.DATE]: (
            <InfoModalGeneral
                content={dateContent}
                show={show}
                setShow={setShow}
            />
        ),
        [InfoType.NIGHTS]: (
            <InfoModalGeneral
                content={nightsContent}
                show={show}
                setShow={setShow}
            />
        ),
        [InfoType.LANGUAGE]: (
            <InfoModalGeneral
                content={languageContent}
                show={show}
                setShow={setShow}
            />
        ),
        [InfoType.EXTRA_NIGHTS]: (
            <InfoModalGeneral
                content={extraNightsContent}
                show={show}
                setShow={setShow}
            />
        ),
        [InfoType.CANCELLATION_POLICY]: (
            <InfoModalGeneral
                content={cancellationPolicyContent}
                show={show}
                setShow={setShow}
            />
        ),
        [InfoType.TOURTYPE]: (
            <InfoModalDouble
                content={qualityPremiumContent}
                show={show}
                setShow={setShow}
            />
        ),
        [InfoType.VIDEO_JOURNEY]: (
            <InfoModalVideo
                content="/video/video.mp4"
                show={show}
                setShow={setShow}
            />
        ),
        [InfoType.MODAL_PREMIUM]: (
            <InfoModalPremium
                show={show}
                setShow={setShow}
                onBuy={onBuy}
                pricePremium={pricePremiumUse.price}
                priceQuality={priceQualityUse.price}
            />
        ),
    };

    useEffect(() => {
        dispatchCheckout({
            type: "UPDATE_ORDER_DATA",
            payload: {
                originalAmount: priceTotal.price,
                totalAmount: priceTotal.price - (discountAmount || 0),
            },
        });
        dispatchCheckout({
            type: "SET_PRICE_ROOM",
            payload: priceTotal.roomCurrent.map(res => ({
                grossPrice: res?.grossPrice ?? "",
                type: res?.type ?? "",
            })),
        });
    }, [priceTotal.price, discountAmount, dispatchCheckout]);

    console.log("languages", languages);
    // useEffect(() => {
    // const url = new URL(window.location.href);
    // url.searchParams.set("clickLanguage", true as unknown as string);
    // window.history.replaceState(null, "", url);
    // });
    return (
        <div
            className={`${styles.configurator} ${
                isPremium
                    ? `${styles.configuratorBorderPremium}`
                    : `${styles.configuratorBorderQuality}`
            }`}
        >
            {modalsInfo[infoContent]}
            {/* <h3 className={styles.configuratorTitle}>Customize your Journey</h3>
            <p className={styles.configuratorDescription}>
                We&apos;re here to make your booking experience seamless. For
                extra help, please follow our easy guide.
            </p>
            <MDBBtn
                className={styles.configuratorWatchTutorialButton}
                onClick={() => toggleInfoModal(InfoType.VIDEO_JOURNEY)}
            >
                <span>Watch tutorial</span>
                <div className="ps-3 pt-1">
                    <PlayLine />
                </div>
            </MDBBtn>
            <div className={styles.configuratorDivider} /> */}
            {/* <LanguageSectionDetail
                languages={languages}
                selectedSlot={selectedSlot}
                overrideDate={overrideDate}
                startDate={startDate}
                clickLanguage={clickLanguage}
                setClickLanguage={setClickLanguage}
            /> */}
            {/* <div className={styles.configuratorDivider} /> */}
            <DatePickerSectionDetail
                toggleInfoModal={toggleInfoModal}
                days={+days}
                daysExcluded={daysExcluded}
                discountedDates={discountedDates}
                isPremium={isPremium}
                slots={slots}
                startDate={startDate}
                setStartDate={setStartDate}
                setStartDateView={setStartDateView}
                startDateView={startDateView}
                click={clickDate}
                setClick={setClickDate}
            />
            <div className={styles.configuratorDivider} />
            <RoomTravellersSectionDetail
                rooms={roomStore}
                calculateSelectedSlot={calculateSelectedSlot}
                errorGuest={errorGuest}
                setErrorGuest={setErrorGuest}
                pets={pets}
                setPets={setPets}
                eccessoList={eccessoList}
                setEccessoList={setEccessoList}
            />
            {typePackage === ETypePackage.QUALITY_AND_PREMIUM && (
                <>
                    <div className={styles.configuratorDivider} />
                    <ChooseExperienceSectionDetail
                        isPremium={isPremium}
                        setIsPremium={setIsPremium}
                        pricePremium={pricePremiumUse.price}
                        priceQuality={priceQualityUse.price}
                    />
                </>
            )}
            <div className={styles.configuratorDivider} />
            <PackageConfigurationSectionDetail
                isPremium={isPremium}
                days={+days}
                startDate={startDateView}
                // price={calculatePrice}
            />
            <div className={styles.configuratorDivider} />
            <FinalPriceSectionDetail
                price={totalAmount}
                toggleInfoModal={toggleInfoModal}
                showPrice={clickDate}
            />
            <div className={styles.configuratorDivider} />
            <ButtonBuySectionDetail
                errorGuest={errorGuest}
                toggleInfoModal={toggleInfoModal}
                clickDate={clickDate}
                setShowModalPremium={showModalPremium}
                onBuy={onBuy}
                isPremium={isPremium}
            />

            <h4
                className={styles.configuratorCancellationPolicyText}
                onClick={() => toggleInfoModal(InfoType.CANCELLATION_POLICY)}
                style={{ color: "red" }}
            >
                Free cancellation policy available
            </h4>
            <div className={styles.configuratorFaqContainer}>
                <Link
                    className={styles.configuratorFaqText}
                    href="/faq"
                    target="_blank"
                    style={{ textDecoration: "underline" }}
                >
                    FAQ
                </Link>
            </div>
        </div>
    );
};

export default DetailBookingConfigurator;
